import { render, staticRenderFns } from "./SLType.vue?vue&type=template&id=fe61b18a"
import script from "./SLType.vue?vue&type=script&lang=js"
export * from "./SLType.vue?vue&type=script&lang=js"
import style0 from "./SLType.vue?vue&type=style&index=0&id=fe61b18a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports